import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetSlideStyleParams {
  isLastSlide: boolean;
  indents: ISliderIndents;
}

export function getSlideStyle(params: IGetSlideStyleParams): CSSProperties {
  const { isLastSlide, indents } = params;
  const { beetween = 0 } = indents;

  if (isLastSlide) {
    return {};
  }

  return {
    marginRight: `${beetween}px`,
  };
}
